import React, { CSSProperties } from 'react';
import styles from './style.module.scss';
import Tooltip from '@components-clean/core/tooltip';

type Variant = 'primary' | 'secondary';

export interface BadgeProps {
    children?: React.ReactNode;
    variant?: Variant;
    tooltip?: string;
    maxWidth?: CSSProperties['maxWidth'];
}

const Badge = ({ children, variant = 'primary', tooltip, maxWidth = '30ch' }: BadgeProps) => {
    const text = (
        <span
            className={styles.badgeText}
            title={tooltip}
            style={{
                maxWidth,
            }}
        >
            {children}
        </span>
    );

    return (
        <div className={styles.badge} data-variant={variant}>
            {tooltip != null ? <Tooltip>{text}</Tooltip> : text}
        </div>
    );
};

export default Badge;
